module.exports = __webpack_public_path__ + "media/images/company_4-c66d4dd8d262aff923e95467b626562e.png";